import { useState, useEffect, useRef } from 'react';
import styles from './TextHeader.module.scss';

import PropTypes from 'prop-types';

const TextHeader = ({ header }) => {
    const headerRef = useRef(null);

    const [isTruncated, setIsTruncated] = useState(false);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });

    useEffect(() => {
        if (headerRef.current) {
            const range = new Range();
            range.selectNodeContents(headerRef.current);

            const rangeProps = range.getBoundingClientRect();
            const headerProps = headerRef.current.getBoundingClientRect();

            setIsTruncated(rangeProps.right > headerProps.right);
        }
    }, [headerRef.current, header]);

    const onMouseMove = (event) => {
        const nEvent = event.nativeEvent;
        const { layerX, layerY } = nEvent;

        setPosition({
            x: layerX + 10,
            y: layerY + 10
        });
    };

    const onTextHover = (isHovering) => {
        setIsTooltipVisible(isHovering);
    };

    return (
        <div className={styles.wrapper}>
            {isTooltipVisible && (
                <div
                    className={styles.tooltip}
                    style={{
                        visibility: isTruncated ? 'visible' : 'hidden',
                        top: position.y,
                        left: position.x
                    }}
                >
                    {header}
                </div>
            )}
            <div
                ref={headerRef}
                className={styles.header}
                onMouseMove={onMouseMove}
                onMouseEnter={() => onTextHover(true)}
                onMouseLeave={() => onTextHover(false)}
            >
                {header}
            </div>
        </div>
    );
};

TextHeader.propTypes = {
    header: PropTypes.string
};

export default TextHeader;
